export const NUMBER_OF_LEVERAGE_PRODUCT_OPTIONS = 1;
export const SAVINGS_PLAN_TAG = "savings-plan";
export const REAL_MONEY_TAG = "real-money";

// This tag ids come in hand with isInvestable  switch
export const TAG_IDS_IS_INVESTABLE = [SAVINGS_PLAN_TAG, REAL_MONEY_TAG];
